import script from "./FormItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormItem.vue?vue&type=script&lang=ts&setup=true"

import "./FormItem.vue?vue&type=style&index=0&id=0ad5d7fc&lang=css"

const __exports__ = script;

export default __exports__